export const GUARD_ROUTES = {
  conversations: {
    root: '/conversations',
  },
  organizations: {
    root: '/organizations',
    create: '/organizations/create',
  },
  settings: {
    root: '/settings',
    billing: '/settings/workspace/billing',
  },
  payment: {
    success: '/payment/success',
    cancel: '/payment/cancel',
  },
  contactSupport: '/contact-support',
  admin: '/admin',
} as const;

// Routes that should be accessible without any guards
export const PUBLIC_ROUTES = ['/login', 'logout', '/sign-in', '/sign-up', '/404', '/500'] as const;

// Routes that are accessible without an organization
export const ORGANIZATION_FREE_ROUTES = [GUARD_ROUTES.organizations.root] as const;

// Routes that are accessible without a subscription
export const SUBSCRIPTION_FREE_ROUTES = [
  ...ORGANIZATION_FREE_ROUTES,
  GUARD_ROUTES.settings.root,
  GUARD_ROUTES.payment.success,
  GUARD_ROUTES.payment.cancel,
  GUARD_ROUTES.admin,
] as const;
